import React, { Component } from 'react';
import { localize } from 'react-localize-redux';
import styled, { css } from 'styled-components';
import { connect } from 'react-redux';
import { toFriendlyDateString, formatMoney, toFriendlyDateTimeString } from 'helpers/Formatter';
import { getTranslatedString, getCurrentLocale } from 'helpers/i18n';
import camelCase from 'lodash/camelCase';
import MediaQuery from 'react-responsive';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { colors } from 'helpers/ColorHelper';

const Entry = styled.div`
  border-bottom: 1px solid #eaeaea;
  padding: 15px 0;
`;

const EntryTitle = styled.div`
  font-family: 'Circular-Black';
  font-size: 16px;
`;

const EntryAmount = styled.div`
  font-family: 'Circular';
  font-size: 16px;
  text-align: right;

  ${(props) =>
    props.credit &&
    css`
      color: green;
    `};

  ${(props) =>
    props.debit &&
    css`
      color: red;
    `};
`;

const ProcessedAtDiv = styled.div`
  text-align: right;
  @media (max-width: 991px) {
    text-align: left;
  }
`;

class YardiLedger extends Component {
  render() {
    const ledger = this.props.ledger;
    const reversedLedger = [...ledger].reverse();

    return (
      <div>
        {reversedLedger.map((entry, index) => (
          <Entry key={index}>
            <div className="row">
              <div className="col-xs-6">
                <EntryTitle>
                  {getTranslatedString(
                    `landlordPortal.paymentsLedger.${camelCase(entry.payment_type)}`
                  )}
                </EntryTitle>
              </div>
              <div className="col-xs-6">
                {entry.tenant_amount > 0 && (
                  <EntryAmount debit>{formatMoney(entry.tenant_amount)}</EntryAmount>
                )}
                {entry.tenant_amount_received > 0 && (
                  <EntryAmount credit>-{formatMoney(entry.tenant_amount_received)}</EntryAmount>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-md-6">{entry.description}</div>
              <MediaQuery query="(min-width: 600px)">
                <ProcessedAtDiv className="col-xs-6">
                  {getTranslatedString('tenantPortal.yardiLedger.processedOn')}{' '}
                  {toFriendlyDateString(entry.due_date, { language: this.props.currentLanguage })}
                </ProcessedAtDiv>
              </MediaQuery>
              <MediaQuery query="(max-width: 600px)">
                <div className="col-xs-12">
                  {getTranslatedString('tenantPortal.yardiLedger.processedOn')}{' '}
                  {toFriendlyDateString(entry.due_date, { language: this.props.currentLanguage })}
                </div>
              </MediaQuery>
            </div>
            {entry.extra_details && Object.keys(entry.extra_details).length > 0 && (
              <AdditionalDetails
                expand={this.props.expandedRows.includes(index)}
                handleExpandClick={this.props.handleRowClickIndex.bind(this, index)}
                extraDetails={entry.extra_details}
              />
            )}
          </Entry>
        ))}
      </div>
    );
  }
}

YardiLedger = connect((state) => ({
  currentLanguage: state.locale.currentLanguage,
}))(YardiLedger);

export default localize()(YardiLedger);

const AdditionalDetails = ({ expand, handleExpandClick, extraDetails }) => {
  let lastDigits = extraDetails.last_digits || '';
  if (lastDigits.length === 4) {
    lastDigits = `**** **** **** ${extraDetails.last_digits}`;
  }

  return (
    <div className="row" style={{ marginTop: '10px' }} onClick={handleExpandClick}>
      <div className="col-xs-12" style={{ display: 'flex', alignItems: 'center' }}>
        <h5
          style={{
            margin: '0',
            marginRight: '5px',
            fontWeight: 'bold',
          }}
        >
          {getTranslatedString('tenantPortal.yardiLedger.paymentMethod')}
        </h5>{' '}
        <span>
          {extraDetails.card_type} {lastDigits}
        </span>
      </div>
      {expand ? (
        <React.Fragment>
          <div className="row">
            <div className="col-xs-12" style={{ display: 'flex', alignItems: 'center' }}>
              <h5 style={{ margin: '0', marginRight: '5px', fontWeight: 'bold' }}>
                {getTranslatedString('tenantPortal.yardiLedger.merchantRefNum')}
              </h5>{' '}
              <span>{extraDetails.merchant_ref_num}</span>
            </div>
            <div className="col-xs-12" style={{ display: 'flex', alignItems: 'center' }}>
              <h5 style={{ margin: '0', marginRight: '5px', fontWeight: 'bold' }}>
                {getTranslatedString('tenantPortal.yardiLedger.providerRefId')}
              </h5>{' '}
              <span>{extraDetails.provider_ref_id}</span>
            </div>
            <div className="col-xs-12" style={{ display: 'flex', alignItems: 'center' }}>
              <h5 style={{ margin: '0', marginRight: '5px', fontWeight: 'bold' }}>
                {getTranslatedString('tenantPortal.yardiLedger.paidOn')}
              </h5>{' '}
              <span>
                {toFriendlyDateTimeString(extraDetails.time_stamp, {
                  language: getCurrentLocale(),
                })}
              </span>
            </div>
            {extraDetails.auth_code && (
              <div className="col-xs-12" style={{ display: 'flex', alignItems: 'center' }}>
                <h5 style={{ margin: '0', marginRight: '5px', fontWeight: 'bold' }}>
                  {getTranslatedString('tenantPortal.yardiLedger.authCode')}
                </h5>{' '}
                <span>{extraDetails.auth_code}</span>
              </div>
            )}
          </div>
          <div
            className="col-xs-12"
            style={{
              marginTop: '15px',
              display: 'flex',
              justifyContent: 'center',
              color: colors.LINK_BLUE,
            }}
          >
            {getTranslatedString('tenantPortal.yardiLedger.hideDetails')}{' '}
            <span>
              <ExpandLessIcon style={{ color: colors.LINK_BLUE }} />
            </span>
          </div>
        </React.Fragment>
      ) : (
        <div
          className="col-xs-12"
          style={{
            marginTop: '15px',
            display: 'flex',
            justifyContent: 'center',
            color: colors.LINK_BLUE,
          }}
        >
          {getTranslatedString('tenantPortal.yardiLedger.expandDetails')}{' '}
          <span>
            <ExpandMoreIcon style={{ color: colors.LINK_BLUE }} />
          </span>
        </div>
      )}
    </div>
  );
};
